/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-12-28 16:57:20
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsySignature from '../BsySignature';
import BsyThumbList from '../BsyThumbList';
import './index.css'
import BsySubformBase from '../BsySubformBase';

class BsySubformSignature extends BsySubformBase {

    static defaultProps = {
        baseCls: "bsy-subform-upload",

    }

    constructor(props) {
        super({
            baseCls: "bsy-subform-upload",
            ...props
        });

        this.element = React.createRef();
    }

    getValue = () => {
        const { value } = this.state
        return value
    }

    setValue = (value) => {
        this.setState({
            value: value
        })
    }

    componentDidMount() {
        super.componentDidMount()

    }

    popUpPane = () => {
        const { items, value } = this.state;
        let that = this;
        that.isChange = false;
        return <BsySignature
            {...that.options}
            getContext={null}
            baseCls={"bsy-signature bsy-upload subform"}
            customCls={''}
            width={'auto'}
            value={value}
            dataId={this.props.dataId}
            formId={this.props.formId}
            appId={this.props.appId}
            is_file_down={this.props.is_file_down}
            online_edit={this.props.online_edit}
            online_edit_record={this.props.online_edit_record}
            onStopEdit={(e) => {
                that.isChange = true;
                that.setState({
                    value: [...e],
                })
            }}
        ></BsySignature>
    }

    popUpPaneClose = (e) => {
        let that = this;
        if (e && e.target) {

            if (e.target.classList.contains('use') ||
                e.target.classList.contains('again') ||
                BsyUtils.closestClass(e.target, 'qrcode-dropdown')) {
                return
            }

        }
        if( that.isChange )
            BsyUtils.applyFunc(that, that.props.onStopEdit, [that.state.value, null, that], !1) 
        else {
            BsyUtils.applyFunc(that, that.props.onClose, [that.state.value, null, that], !1) 
        }
        return !1;
    }

    renderDisablePane = () => {
        const { value } = this.state;
        if (BsyUtils.isObjectEmpty(value)) {
            return <div className={"bsy_form_item_disable "} data-watermark={React.language('content.empty')}  ></div>
        }
        return <div className={"bsy_form_item_disable "} data-watermark={React.language('content.empty')}  >
            <BsyThumbList
                widget={this.options}
                dataId={this.props.dataId}
                formId={this.props.formId}
                appId={this.props.appId}
                files={value} />
        </div>
    }

    render() {
        const { value } = this.state
        const { cssName, hasPreview, hasTooltip,css } = this.options
        if (!this.isEnabled()) {
            return this.renderDisablePane()
        }
        return (
            <div className={cssName}
                style={css}
                ref={this.element}
                onClick={(e) => {
                    this._onTriggerClick(e,340)
                }}
            >
                <div className="select-trigger">
                    <BsyThumbList
                        widget={this.options}
                        hasPreview={hasPreview}
                        hasTooltip={hasTooltip}
                        dataId={this.props.dataId}
                        formId={this.props.formId}
                        appId={this.props.appId}
                        files={value} />
                    {
                        this.renderBtn('icon-widget-signature', value)
                    }
                </div>
            </div>
        );
    }
}

export default BsySubformSignature;